import { useCallback } from 'react';

const useExtractEventId = (selectedEvent: string) => {
    const extractEventId = useCallback((urlParams: string, pattern: string): string => {
        let selectedEventId = selectedEvent;
        if (!selectedEventId && urlParams.includes(pattern)) {
            const currentDecodePageUrl = decodeURI(urlParams);
            selectedEventId = currentDecodePageUrl.substring(urlParams.lastIndexOf(pattern) + pattern.length).replace(/\'/g, '');
            const currentPageURL = decodeURI(window.location.href);
            const hashWithOutEventId = decodeURI(window.location.hash).replace(/\'/g, '').replace(`${pattern}${selectedEventId}`, '');
            window.history.pushState(null, 'Video Event', `${window.location.pathname}${hashWithOutEventId}`);
            window.history.pushState(null, 'Video Event', `${currentPageURL.replace(/\'/g, '').replace(selectedEventId, `'${selectedEventId}'`)}`);
        }
        return selectedEventId;
    }, [selectedEvent]);

    return extractEventId;
};

export default useExtractEventId;
